export default "__VITE_ASSET__zbWXo9Rj__"